import { styled } from 'styled-components';
import { color } from './var';
import { $fontSize, $marginBottom } from './mediaSize';

export const TipsWrap = styled.div`
  ${$fontSize('20rem', '12rem')}
  ${$marginBottom('24rem', '20rem')}
  color: ${color.gray};
  text-align: center;
`;
